var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PropertyConverters } from '../../converters';
import { Watch, CustomElement } from '../../decorators';
import { P } from '../../prefix';
import { TweenAnimationElement } from './animation';
//namespace Pacem.Components {
const DEFAULT_FROM = { x: 0, y: 0 };
const DEFAULT_TO = { x: 1, y: 1 };
let PacemPointAnimationElement = class PacemPointAnimationElement extends TweenAnimationElement {
    tweenInterpolationCallback(time, progress) {
        const to = this.to ?? DEFAULT_TO, from = this.from ?? DEFAULT_FROM;
        return {
            x: (to.x - from.x) * progress + from.x,
            y: (to.y - from.y) * progress + from.y
        };
    }
};
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemPointAnimationElement.prototype, "from", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Point })
], PacemPointAnimationElement.prototype, "to", void 0);
PacemPointAnimationElement = __decorate([
    CustomElement({ tagName: P + '-point-animation' })
], PacemPointAnimationElement);
export { PacemPointAnimationElement };
//}
